module.exports = __webpack_public_path__ + "mm.a210c6ba321d73bbb89e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mm.svg
// module chunks = styles